import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Divider, Typography, Box } from '@material-ui/core';

import useProducts from 'utils/hooks/useProducts';
import Icon from 'components/Icon';

import { Configuration } from '../types';
import { getDonationProductId } from '../rdx/reducer';

import { ProductSearch } from './ProductSearch';

type DonationConfProps = {
  save: (donationId: Configuration['donationProductId']) => void;
};

export const DonationProductConfig: FC<DonationConfProps> = ({ save }) => {
  const { t } = useTranslation('customerDisplay');
  const donationID = useSelector(getDonationProductId);

  const [donationProductId, setDonationProductId] = useState(donationID);
  const {
    products: [donationProduct],
  } = useProducts({ productID: donationProductId });

  function resetConfig() {
    setDonationProductId(0);
    save(0);
  }

  return (
    <div style={{ marginTop: '10px', overflowX: 'auto' }}>
      <Typography variant="h5">{t('donationForm.title')}</Typography>
      {donationProductId === 0 || !donationProduct ? (
        <Typography variant="body1" style={{ fontWeight: 'bold' }}>
          {t('donationForm.noProduct')}
        </Typography>
      ) : (
        <Box display="flex" alignItems="center" marginTop={2}>
          <Typography variant="body1" style={{ fontWeight: 'bold' }}>
            {t('donationForm.product', {
              name: donationProduct?.name,
            })}
          </Typography>
          <Icon
            key="icon_trash_alt"
            name="icon_trash_alt"
            title={t('productsTable.actions.clear')}
            action={() => resetConfig()}
            data-testid="clear-donation-product"
            style={{
              color: 'red',
            }}
          />
        </Box>
      )}

      <ProductSearch
        handleProductSelect={(donationId: number) => {
          setDonationProductId(donationId);
          save(donationId);
        }}
        productType="donation"
        selectedProductId={donationProductId}
      />
      <Divider />
    </div>
  );
};
